import type { RestangularService } from '../components/common/restangular.service'

import { app } from '../app.module'
export interface IGroup {
  groupName: string
  groupId: number
  isAdmin: number
  plan: string
  flgFacebook: number
  flgTwitter: number
  flgInstagram: number
  flgYoutube: number
  flgLine: number
  flgTiktok: number
  flgPost: number
  flgAccount: number
  flgAnalytics: number
  flgArchive: number
  status: number
  maxUserCount: number
}

/**
 * グループ処理用サービス
 */
export class GroupService {
  constructor(
    private $rootScope,
    private $state,
    private localStorageService,
    private CommonService,
    private RestangularService: RestangularService
  ) {}

  /**
   * 選択したグループの情報を、ルートスコープに格納
   * @param {object} selectedGroup 選択しているグループのデータ
   * @return {object} グループ名
   */
  public setGroupData(selectedGroup: IGroup): void {
    this.$rootScope.groupMaxUserCount = selectedGroup.maxUserCount
    this.$rootScope.isAdmin = selectedGroup.isAdmin === 1 ? true : false
    this.$rootScope.groupName = selectedGroup.groupName
    this.$rootScope.groupId = selectedGroup.groupId
    // 0: デモ 1:契約中 2: 社内利用
    this.$rootScope.groupStatus = selectedGroup.status
    // 契約プランと、SNSの利用制限フラグをセットする
    this.$rootScope.isPro = selectedGroup.plan === 'pro'
    this.$rootScope.flgFacebook = selectedGroup.flgFacebook === 1
    this.$rootScope.flgTwitter = selectedGroup.flgTwitter === 1
    this.$rootScope.flgInstagram = selectedGroup.flgInstagram === 1
    this.$rootScope.flgYoutube = selectedGroup.flgYoutube === 1
    this.$rootScope.flgLine = selectedGroup.flgLine === 1
    this.$rootScope.flgTiktok = selectedGroup.flgTiktok === 1
    // 機能の制限フラグをセットする
    this.$rootScope.flgPost = selectedGroup.flgPost === 1
    this.$rootScope.flgAccount = selectedGroup.flgAccount === 1
    this.$rootScope.flgAnalytics = selectedGroup.flgAnalytics === 1
    this.$rootScope.flgArchive = selectedGroup.flgArchive === 1

    // 現在選択中のグループを選択中のグループとして保存
    this.localStorageService.set('selectedGroupId', selectedGroup.groupId)
    this.CommonService.getBrandIdList()
  }

  /**
   * グループ切り替える後の処理
   * @param {number} selectedGroupId 選択しているグループID
   * @param {boolean} resetParamFlg URLのパラメーターリセットフラグ
   */
  public changeGroup(selectedGroupId: number, resetParamFlg: boolean): void {
    const endpoint = '/users/getGroupData'
    const params = {}

    this.RestangularService.request('GET', endpoint, params).then((result) => {
      const groupList = result[0].data
      const selectedGroup = groupList.filter((group) => {
        return Number(group.groupId) === Number(selectedGroupId)
      })

      this.setGroupData(selectedGroup[0])

      let params = {}

      // グループ切り替える場合、パラメーターをリセット
      if (resetParamFlg === true) {
        params = {
          type: '',
          id: '',
          snsType: '',
          groupId: '',
        }
      }

      // 再リロードする
      if (this.$state.current !== undefined) {
        this.$state.go(this.$state.current.name, params, {
          reload: true,
        })
      }
    })
  }
}

app.service('GroupService', GroupService)
